import { ContactCreatedEvent } from '@rematter/frontend-lib-api-client/grpc/crm/v1/contact_events_pb';
import { Col, FieldDisplay, IDField } from '@rematter/ui-web';

type ContactCreatedDetailProps = {
  event: ContactCreatedEvent;
};

export const ContactCreatedDetail = ({ event }: ContactCreatedDetailProps) => {
  const contact = event.contact;

  if (!contact) {
    return (
      <Col className="@ContactCreatedDetail items-center justify-center p-4 text-neutral/40">
        <span>No data available</span>
      </Col>
    );
  }

  return (
    <Col className="@ContactCreatedDetail gap-3" gap3>
      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap2>
        <span className="text-xs font-medium text-neutral/60">
          Contact Details
        </span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <IDField label="ID" value={contact.id?.value} />
          <FieldDisplay label="Full Name" value={contact.fullName} />
          <FieldDisplay label="Email" value={contact.email} />
          <FieldDisplay label="Phone" value={contact.phone} />
          <FieldDisplay label="Role" value={contact.role} />
          <FieldDisplay label="Department" value={contact.department} />
          <IDField label="Account ID" value={contact.accountId?.value} />
        </div>
      </Col>
    </Col>
  );
};
